import React, { useEffect, useRef, useState } from "react";

export default function CityPicker({
    value = "",
    onChange,
    onPick,
    placeholder = "Місто",
}) {
    const API_URL = "https://api.novaposhta.ua/v2.0/json/";
    const API_KEY = "92b6f560ed7fd3572193becd8d3b26e1";
    const boxRef = useRef(null);

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    // debounce введення
    const debounced = useDebounce(value, 300);

    useEffect(() => {
        if (!debounced || debounced.trim().length < 2) {
            setItems([]);
            return;
        }
        let cancelled = false;

        (async () => {
            setLoading(true);
            try {
                const body = {
                    apiKey: API_KEY,
                    modelName: "AddressGeneral",
                    calledMethod: "getSettlements",
                    methodProperties: {
                        FindByString: debounced.trim(),
                        Page: "1",
                    },
                };
                const res = await fetch(API_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(body),
                });
                const json = await res.json();

                // беремо тільки назву міста (без області)
                const list =
                    json?.data?.map((d) => ({
                        name: d.Description,     // ← лише місто
                        ref: d.Ref,              // CityRef для пошуку відділень
                    })) ?? [];

                if (!cancelled) setItems(list);
            } catch {
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [debounced]);

    // закриття списку по кліку поза
    useEffect(() => {
        const handler = (e) => {
            if (!boxRef.current) return;
            if (!boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const pick = (city) => {
        // віддаємо вибір у батьківський компонент
        onPick && onPick({ name: city.name, ref: city.ref });
        // підставляємо текст у поле
        onChange && onChange(city.name);
        // закриваємо і чистимо список
        setOpen(false);
        setItems([]);
    };

    return (
        <div className="cp" ref={boxRef}>
            <input
                className="cp__input"
                placeholder={placeholder}
                value={value}
                onChange={(e) => {
                    onChange && onChange(e.target.value);
                    !open && setOpen(true);
                }}
                onFocus={() => setOpen(true)}
                autoComplete="off"
            />

            {open && (items.length > 0 || loading) && (
                <div className="cp__dropdown" role="listbox">
                    {loading && <div className="cp__loading">Завантаження…</div>}
                    {!loading &&
                        items.map((c) => (
                            <button
                                key={c.ref}
                                type="button"
                                className="cp__item"
                                onMouseDown={(e) => {
                                    // щоб клік не закрив дроп перед pick()
                                    e.preventDefault();
                                    pick(c);
                                }}
                            >
                                {c.name}
                            </button>
                        ))}
                    {!loading && items.length === 0 && (
                        <div className="cp__empty">Нічого не знайдено</div>
                    )}
                </div>
            )}
        </div>
    );
}

/* ------------ helpers ------------ */
function useDebounce(value, delay) {
    const [v, setV] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setV(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    return v;
}
